var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowChartArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 59,
    viewBox: "0 0 174 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7797_23389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.104 57.288C154.336 58.3615 153.19 58.9844 151.976 58.9844H28.0556C22.5 59 11 61 4 52.5C-0.999735 46 -0.000142008 42 -0.000117362 31C0.0604046 18.5037 -1.00015 13.5 3.37836 7.50457C10.4996 -2.16143 19.4996 0.50282 27.8181 -0.00241625C30.0527 -0.00241625 151.976 -0.00241625 151.976 -0.00241625C153.19 -0.00241625 154.336 0.62045 155.104 1.6939L172.878 26.4893C174.127 28.2253 174.127 30.7433 172.878 32.4794L155.104 57.2748V57.288Z",
    fill: "url(#paint0_linear_7797_23389)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7797_23389",
    x1: 151.5,
    y1: -6.00001,
    x2: 30.9999,
    y2: 72.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B63B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#9AD95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#A1E161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#99D859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78B63B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7797_23389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChartArrow);
export default __webpack_public_path__ + "static/media/flow_chart_arrow.88ac23446b037131bda89f93dec675ab.svg";
export { ForwardRef as ReactComponent };